(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
    // Scroll To top
    document.addEventListener('DOMContentLoaded', function() {
    var scrollButton = document.getElementById('scroll');
    // Hide the scroll button initially
    scrollButton.classList.add('scrollhide');
    window.addEventListener('scroll', function() {
        if (window.scrollY === 0) {
            scrollButton.classList.add('scrollhide');
        } else {
            scrollButton.classList.remove('scrollhide');
        }
    });
    scrollButton.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.trans = this.dataset.trans;
      this.trans_header_bg = this.dataset.trans_header_bg;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      if (window.matchMedia('(min-width: 992px)')) {
      if(this.trans == 'true' && this.trans_header_bg == 'false'){
        this.addEventListener("mouseenter", (event) => {
          if(!this.header.classList.contains('scrolled-past-header'))
            this.classList.remove('transparent_header');
        });
        this.addEventListener("mouseleave", (event) => {
          if(!this.header.classList.contains('scrolled-past-header'))
            this.classList.add('transparent_header');
        });
      }
    }

  if (window.matchMedia('(max-width: 991px)').matches) {
      if (this.trans === 'true' && this.trans_header_bg === 'false') {
        const headerWrapper = this; // store the header wrapper element
        let isMenuDrawerClicked = false; // flag to track whether menu drawer was clicked

        // Add event listener to header wrapper element
        headerWrapper.addEventListener("click", (event) => {
          if (!headerWrapper.classList.contains('scrolled-past-header') && !isMenuDrawerClicked) {
            headerWrapper.classList.toggle('transparent_header');
          }
          isMenuDrawerClicked = false; // reset flag
        });

        // Add event listener to menu drawer element to stop event propagation
        const menuDrawer = headerWrapper.querySelector('.menu-drawer');
        menuDrawer.addEventListener("click", (event) => {
          event.stopPropagation();
          isMenuDrawerClicked = true; // set flag to true
        });

        // Add event listeners for focusin and focusout
        headerWrapper.addEventListener("focusin", (event) => {
          if (!event.target.closest('.menu-drawer')) {
            headerWrapper.classList.add('transparent_header');
          }
        });
        headerWrapper.addEventListener("focusout", (event) => {
          if (!event.target.closest('.menu-drawer')) {
            headerWrapper.classList.remove('transparent_header');
          }
        });
      }
    }

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
 var shopifySectionHeader = document.querySelector('.shopify-section-header-sticky');
    var spanElement = shopifySectionHeader.querySelector('sticky-header');
    var childElement = shopifySectionHeader.querySelector('.header__inline-menu');
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(this.trans != 'false') this.classList.remove('transparent_header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(this.trans != 'false') this.classList.remove('transparent_header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if(this.trans != 'false') this.classList.add('transparent_header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbquickview"]) return;
  try {
    
            class ProductModal extends ModalDialog {
                constructor() {
                super();
                }

                hide() {
                super.hide();
                }

                show(opener) {
                super.show(opener);
                this.showActiveMedia();
                }

                showActiveMedia() {
                this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                    element.classList.remove('active');
                    }
                )
                const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
                const activeMediaTemplate = activeMedia.querySelector('template');
                const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
                activeMedia.classList.add('active');
                activeMedia.scrollIntoView();

                const container = this.querySelector('[role="document"]');
                container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

                if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                    activeMedia.loadContent();
                }
            }

            customElements.define('product-modal', ProductModal);
            
  } catch(e) { console.error(e); }
})();
})();
